import { useMemo } from 'react';
import { useEditorTools } from '../context';
import type { EditorModalName } from './useEditorModals';

export const useEditorTool = (name: EditorModalName) => {
  const editorTools = useEditorTools();

  return useMemo(
    () => ({
      isOpen: editorTools.state[name],
      open: () => editorTools.open(name),
      close: () => editorTools.close(name),
      toggle: () => editorTools.toggle(name),
    }),
    [name, editorTools]
  );
};
